<template>
  <div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_ante`) }}
      </div>
      <div style="width:50%">
        {{ (bet / 100).toFixed(2) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_mylp_type`) }}
      </div>
      <div style="width:50%">
        {{ geValue }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_zjjg`) }}
      </div>
      <div style="width:50%">
        {{ winType }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_zj_win_index`) }}
      </div>
      <div style="width:50%">
        {{ getWinIndex(winIndex) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_zj_odds`) }}
      </div>
      <div style="width:50%">
        {{ odds }}
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :describe_title="describe_title"
      :isTotalWin="isTotalWin"
      :describe_content="describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";
import {game_3008} from "./game_3008";

export default {
  name: "Game3008",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    geValue:0,
    bet:0,
    odds:0,
    winType:0,
    winIndex:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    getWinIndex(index)
    {
      console.log(index);
      return game_3008.getWinIndex(this,index);
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3008.vue